interface Props {
  emoji?: string;
  label: string;
  selected: boolean;
  onClick: () => void;
}

export function OptionPill({ emoji, label, selected, onClick }: Props) {
  return (
    <button
      type="button"
      className={'fb-option' + (selected ? ' fb-option--selected' : '')}
      onClick={onClick}
      aria-pressed={selected}
    >
      {emoji && <span className="fb-option__emoji">{emoji}</span>}
      <span>{label}</span>
      {selected && (
        <span className="fb-option__check" aria-hidden="true">
          &#10003;
        </span>
      )}
    </button>
  );
}
